import React from 'react';

export const FAQ_TABS_DATA = [
	{
		tab: 'سرویس فروش  آگهی تخفیف',
		data: [
			{
				heading: 'ثبت نام و عقد قرارداد سرویس خدمات تخفیفانی:',
				data: [
					{
						question: 'چطور می توانم کسب و کارم را در تخفیفان ثبت کنم؟',
						answer: `به بخش "کسب و کار من" در تخفیفان بروید و جهت ثبت نام گزینه "خدمات تخفیفانی" را انتخاب کنید. پس از ثبت اطلاعات اولیه، کارشناسان واحد فروش جهت ارائه مشاوره های تخصصی با شما در ارتباط خواهند بود.`,
					},
					{
						question: `مدارک مورد نیاز جهت عقد قرارداد با تخفیفان چیست؟`,
						answer: (
							<p className='ws-pre-wrap'>
								{`مدارک مورد نیاز جهت عقد قرارداد افراد حقیقی:  کارت ملی صاحب کسب و کار، شماره شبا، مجوز فعالیت\nمدارک مورد نیاز جهت عقد قرارداد حقوقی: شناسه ملی، کد اقتصادی`}
							</p>
						),
					},
					{
						question: `هزینه ثبت نام و درج آگهی در تخفیفان چقدر است؟`,
						answer: `درج آگهی و ورود به تخفیفان رایگان است. پس از تحقق فروش، درصدی از مبلغ فروش به عنوان کارمزد به تخفیفان تعلق می گیرد. برای مشخص نمودن درصد تخفیف و کارمزد، کارشناسان ما با توجه به دسته بندی  کسب و کار شما، بهترین مشاوره را ارائه خواهند داد`,
					},
				],
			},
			{
				heading: 'ورود به پنل کسب و کار :',
				data: [
					{
						question: 'چگونه وارد پنل کاربری خود شوم؟',
						answer: (
							<p>
								جهت ورود به پنل کسب و کار خود وارد سایت تخفیفان شوید و از بخش "
								<a
									className='txt-secondary'
									href={`${process.env.API_BASE_URL}/pwa/login`}
								>
									کسب و کار من
								</a>
								" شماره موبایل خود را وارد کنید و با وارد کردن رمز یکبار مصرف
								ارسالی به شماره همراه، وارد پنل خود شوید
							</p>
						),
					},
					{
						question: `در صورت فراموشی نام کاربری و رمز عبور چه کنم؟ `,
						answer: (
							<p className='ws-pre-wrap'>{`شما همواره می توانید از طریق رمز یکبار مصرفی که در همان لحظه به شماره همراه شما پیامک می شود به پنل خود وارد شوید.\n در صورتی که به موبایل خود دسترسی نداشتید، با واحد پشتیبانی تخفیفان به شماره 02192005412 تماس بگیرید`}</p>
						),
					},
				],
			},
			{
				heading: 'ویرایش کسب و کار و آگهی:',
				data: [
					{
						question: 'چگونه اطلاعات کسب و کار خودم رو تغییر بدهم؟',
						answer: (
							<p className='ws-pre-wrap'>{`پس از ورود به پنل کسب و کار خود، از گزینه "بیشتر"، " تکمیل اطلاعات کسب و کار" را انتخاب کنید.\nدر نظر داشته باشید که امکان تغییر نام ، شماره تماس ، دسته بندی مجموعه و اطلاعات حساب و کد ملی برای شما وجود ندارد و در صورت نیاز به چنین تغییراتی، تیکت ثبت کنید`}</p>
						),
					},
					{
						question:
							'چطور می توانم  آگهی تخفیف جدید ثبت کنم یا  آگهی تخفیف های قبلی را ویرایش کنم؟',
						answer: `پس از ورود به پنل کسب و کار خود، از گزینه " آگهی‌ها"، " سرویس فروش  آگهی تخفیف" را انتخاب کنید. سپس می‌توانید با کلیک روی هر یک از  آگهی تخفیف‌های خود، آن‌را ویرایش کنید و یا با کلیک روی علامت "+" در گوشه‌ی صفحه پایین سمت چپ، اقدام به ساخت یک  آگهی تخفیف جدید کنید.`,
					},
					{
						question: 'چگونه شماره حساب و شبا  را تغییر دهم ؟ ',
						answer: `درخواست خود را در نامه با سربرگ رسمی (به همراه مهر و امضا) ثبت کنید و جهت ارسال به تخفیفان (ثبت تیکت)، پس از ورود به پنل کسب و کار خود، از گزینه "بیشتر"، "تیکت های پشتیبانی" را انتخاب کنید و روی علامت + پایین صفحه کلیک کنید و تصویر نامه را بارگذاری و ارسال کنید`,
					},
				],
			},
			{
				heading: 'ابطال کوپن:',
				data: [
					{
						question: `گونه کوپن های دریافتی از مشتری را باطل کنم؟`,
						answer: (
							<p>{`پس از ورود به پنل تخفیفان، روی دکمه قرمز رنگ وسط صفحه (بارکدخوان) کلیک کنید تا روش های مختلف ابطال کوپن را مشاهده کنید. امکان ابطال کوپن از طریق اسکن  QR کد، شماره سفارش 9 رقمی، کد تخفیفان (4 رقم داخل پرانتز) و شماره همراه کاربر وجود دارد.`}</p>
						),
					},
					{
						question: `چگونه QR Code دریافتی از مشتری را باطل کنم؟`,
						answer: `پس از ورود به پنل تخفیفان، روی دکمه قرمز رنگ وسط صفحه (بارکدخوان) کلیک کنید. پس از فعالسازی دسترسی به دوربین، QR کد ارائه شده توسط کاربر را اسکن کنید تا کوپن ابطال شود.`,
					},
					{
						question: `چگونه با شماره سفارش یا کد تخفیفان، کوپن مشتری را باطل کنم؟`,
						answer: `پس از ورود به پنل تخفیفان، دکمه قرمز رنگ وسط صفحه (بارکدخوان) را انتخاب و سپس روی گزینه "شماره تلفن و روش های دیگر" کلیک کنید. در تب های مختلف این صفحه می توانید با شماره سفارش یا کد تخفیفان نسبت به ابطال کوپن اقدام کنید`,
					},
				],
			},
			{
				heading: 'مدیریت مالی و تسویه حساب:',
				data: [
					{
						question: 'چطور می توانم درخواست تسویه حساب ثبت کنم؟',
						answer: (
							<p className='ws-pre-wrap'>
								{`پس از ورود به پنل کسب و کار خود، از گزینه "بیشتر"، "درخواست تسویه" را انتخاب کنید.\nدر این بخش می توانید مبلغ موجودی پنل خود را مشاهده و درخواست پرداخت آن را ثبت کنید و پس از تائید مبلغ و جزئیات پرداختی، درخواست شما در صف واریز قرار می گیرد.\nحداقل مبلغ قابل پرداخت 50 هزار تومان است`}
							</p>
						),
					},
					{
						question: 'چگونه جزئیات درخواست پرداخت ها را مشاهده کنم؟',
						answer: (
							<p className='ws-pre-wrap'>
								{`پس از ورود به پنل کسب و کار خود، از گزینه "بیشتر"، "درخواست تسویه" را انتخاب کنید. در این بخش می توانید لیست درخواست های پرداخت خود و وضعیت هر یک را مشاهده کنید.\nهمچنین با زدن سه نقطه هر درخواست می توانید شماره پیگیری، تاریخ واریز، اطلاعات حساب بانکی و جزئیات مبلغ پرداختی را مشاهده کنید`}
							</p>
						),
					},
					{
						question: 'چگونه شماره حساب و شبا  را تغییر دهم ؟ ',
						answer: `درخواست خود را در نامه با سربرگ رسمی (به همراه مهر و امضا) ثبت کنید و جهت ارسال به تخفیفان (ثبت تیکت)، پس از ورود به پنل کسب و کار خود، از گزینه "بیشتر"، "تیکت های پشتیبانی" را انتخاب کنید و روی علامت + پایین صفحه کلیک کنید و تصویر نامه را بارگذاری و ارسال کنید`,
					},
				],
			},
			{
				heading: `عوامل موثر در فروش:`,
				data: [
					{
						question: 'چه مواردی در فروش من تاثیرگذار هست؟',
						answer: `میزان تخفیف و کیفیت سرویس ارائه شده، منجر به رضایتمندی مشتریان و کسب امتیاز مثبت بیشتر خواهد شد که تاثیر قابل توجهی بر میزان فروش شما دارد.\nپاسخگویی به سوالات و نظرات مشتریان، عکس و محتوای مناسب نیز از جمله عواملی است که می تواند فروش شما را افزایش دهد`,
					},
				],
			},
			{
				heading: `نظرات، پرسش و پاسخ کاربران:`,
				data: [
					{
						question: `آیا به نظرات کاربران و پاسخگویی به سوالات مشتریان دسترسی دارم؟`,
						answer: (
							<p>{`پس از ورود به پنل کسب و کار خود، از گزینه "بیشتر"، می توانید به سوالات و نظرات ثبت شده کاربران  را مشاهده و به انها پاسخ دهید. در نظر داشته باشید که پاسخگویی به سوالات کاربران در کمترین زمان ممکن می تواند به فروش بیشتر شما کمک کند.`}</p>
						),
					},
				],
			},
			{
				heading: 'راههای ارتباطی با تخفیفان:',
				data: [
					{
						question: `چگونه با کارشناس پشتیبان خود در تماس باشم؟`,
						answer: (
							<p className='ws-pre-wrap'>{`می توانید با ثبت تیکت در پنل، درخواست خود را مطرح کنید تا کارشناس های ما در اسرع وقت با شما تماس بگیرند. جهت ثبت تیکت، پس از ورود به پنل کسب و کار، از گزینه "بیشتر"، "تیکت های پشتیبانی" را انتخاب کنید.\nامکان تماس تلفنی با پشتیبانی نیز (02192005412) در همه صفحات پنل شما (بالای صفحه، سمت چپ) قابل مشاهده است.`}</p>
						),
					},
					{
						question: `چگونه در پنل کسب و کار خود تیکت ثبت کنم؟`,
						answer: (
							<p className='ws-pre-wrap'>{`پس از ورود به پنل کسب و کار، از گزینه "بیشتر"، "تیکت های پشتیبانی" را انتخاب کنید و روی علامت + پایین صفحه کلیک کنید و تیکت را ایجاد کنید. امکان بارگذاری و ارسال تصویر نیز از این بخش وجود دارد.\nتیکت های شما تا 48 ساعت پاسخ داده خواهد شد و می توانید نتیجه آن را در پنل خود مشاهده کنید.`}</p>
						),
					},
				],
			},
		],
	},
	{
		tab: 'آگهی بازگشت وجه حضوری',
		data: [
			{
				heading: 'معرفی سرویس و روش ثبت نام',
				data: [
					{
						question: 'آگهی بازگشت وجه حضوری تخفیفان چطور کار می کند؟',
						answer:
							'با ثبت نام در این سرویس برای شما یک آگهی در سایت پر بازدید تخفیفان ایجاد خواهد شد و مشتریانی که کارت خود را در تخفیفان وارد کرده باشند می توانند پس از مشاهده این تبلیغ، خرید خود را از فروشگاه شما با تخفیف انجام دهند. برای فعالسازی این سرویس کافیست اطلاعات دستگاه کارتخوان خود را در تخفیفان وارد کنید.',
					},
					{
						question:
							'چطور می توانم در آگهی بازگشت وجه حضوری تخفیفان ثبت نام کنم؟',
						answer: `به بخش "کسب و کار من" در تخفیفان بروید و جهت ثبت نام گزینه "بازگشت وجه در محل" را انتخاب کنید. پس از ثبت اطلاعات اولیه و ورود به پنل از منوی سمت راست گزینه "بازگشت وجه" را انتخاب کنید و از بخش ثبت نام اطلاعات دستگاه کارتخوان خود را وارد کنید. کارشناسان واحد فروش جهت ارائه مشاوره های تخصصی با شما در ارتباط خواهند بود.`,
					},
					{
						question: 'هزینه ثبت نام و درج آگهی در تخفیفان چقدر است؟',
						answer: `درج آگهی و ورود به تخفیفان رایگان است. زمان ثبت تراکنش توسط کاربر، درصدی از مبلغ فروش به عنوان کارمزد به مشتری و تخفیفان تعلق می گیرد. برای مشخص نمودن درصد تخفیف و کارمزد، کارشناسان ما با توجه به دسته بندی کسب و کار شما، بهترین مشاوره را ارائه خواهند داد.`,
					},
					{
						question:
							'چه مدارکی برای عقد قرارداد آگهی بازگشت وجه حضوری مورد نیاز میباشد؟',
						answer: (
							<div>
								<li>قرارداد با مهر و امضای صاحب فروشگاه</li>
								<li>داشتن یکی از psp های طرف قرارداد با تخفیفان </li>
							</div>
						),
					},
					{
						question:
							'شرکت پرداخت (PSP) های مورد تایید آگهی بازگشت وجه حضوری تخفیفان چیست؟',
						answer: (
							<div>
								<li>شرکت پرداخت الکترونیک پارسیان</li>
								<li>به پرداخت ملت</li>
								<li>شرکت پرداخت الکترونیک سداد</li>
								<li>شرکت آسان پرداخت</li>
							</div>
						),
					},
					{
						question: 'آیا مشتری تخفیفانی خودش را به من معرفی میکند؟',
						answer:
							'خیر، بعد از انجام تراکنش با ارسال پیامک از سمت تخفیفان، شما از خرید مشتری تخفیفانی مطلع میشوید.',
					},
					{
						question:
							'چگونه دستگاه های پوز جدید را به سیستم بازگشت وجه حضوری تخفیفان اضافه کنم؟',
						answer: `وارد پنل کاربری خود شوید، سپس گزینه بازگشت وجه کلیک کرده و گزینه ثبت نام بازگشت وجه را انتخاب نمایید، گزینه افزودن پوز جدید را انتخاب نمایید، نام بانک( شرکت پرداخت)، شناسه ترمینال یا پایانه، نام مالک دستگاه پوز، نام پوز( نام روی رسید دستگاه پوز) را وارد نمایید و روی دکمه ثبت اطلاعات کلیلک نمایید. در صورتی که کارتخوان ثبت شده شما مورد تائید باشد از طرف کارشناسان تخفیفان جهت ادامه فرآیند با شما تماس گرفته خواهد شد.`,
					},
				],
			},
			{
				heading: 'ورود به پنل کسب و کار :',
				data: [
					{
						question: 'چگونه وارد پنل کاربری خود شوم؟',
						answer: (
							<p>
								جهت ورود به پنل کسب و کار خود وارد سایت تخفیفان شوید و از بخش "
								<a
									className='txt-secondary'
									href={`${process.env.API_BASE_URL}/pwa/login`}
								>
									کسب و کار من
								</a>
								" شماره موبایل خود را وارد کنید و با وارد کردن رمز یکبار مصرف
								ارسالی به شماره همراه، وارد پنل خود شوید
							</p>
						),
					},
					{
						question: 'در صورت فراموشی نام کاربری و رمز عبور چه کنم؟',
						answer: (
							<p className='ws-pre-wrap'>{`شما همواره می توانید از طریق رمز یکبار مصرفی که در همان لحظه به شماره همراه شما پیامک می شود به پنل خود وارد شوید.\n در صورتی که به موبایل خود دسترسی نداشتید، با واحد پشتیبانی تخفیفان به شماره 02192005412 تماس بگیرید`}</p>
						),
					},
					{
						question: 'چگونه اطلاعات کسب و کار خودم رو تغییر بدم؟',
						answer: `جهت تغییر اطلاعات کسب و کار خود وارد قسمت ارتباط با ما ،ثبت تیکت جدید شده و درخواست خود را در تیکت جدیدی ثبت نموده و ارسال بفرمایید .همکاران ما در اسرع وقت تغییرات درخواستی شما را انجام خواهند داد.(در نظر داشته باشید که امکان تغییر نام ، شماره تماس ، دسته بندی مجموعه و اطلاعات حساب و کد ملی برای شما وجود ندارد )`,
					},
				],
			},
			{
				heading: 'مدیریت مالی پنل کسب و کار:',
				data: [
					{
						question: 'چگونه تراکنش های خود در این سرویس را مشاهده کنم؟',
						answer: `وارد پنل کاربری خود شوید، روی گزینه بازگشت وجه کلیک کرده و گزینه لیست تراکنش ها را انتخاب نمایید، تراکنش های شما با جزئیات ( نام مشتری، تاریخ، مبلغ، شماره ترمینال، شماره مشتری) قابل مشاهده میباشد.`,
					},
					{
						question: 'چگونه گزارش فروش آگهی بازگشت وجه حضوری را مشاهده کنم؟',
						answer: `وارد پنل کاربری خود شوید، روی گزینه بازگشت وجه کلیک کرده و گزینه گزارش ها را انتخاب نمایید، گزارش فروش شما بر روی نمودار قابل مشاهده میباشد، در این بخش شما میتوانید تعداد مشتریان جدید، تعداد سفارش ها، مجموع مبلغ سفارش ها و تعداد مشتریانی که سفارش ثبت کرده اند را با فیلتر تاریخ مشاهده نمایید.`,
					},
				],
			},
			{
				heading: 'بهتر دیده شدن کسب و کار من:',
				data: [
					{
						question:
							'آگهی بازگشت وجه حضوری تخفیفان در چه کانال هایی تبلیغات انجام میدهد؟',
						answer: `با فعالسازی آگهی بازگشت وجه حضوری در کانال‌های تبلیغاتی تخفیفان( پلتفرم تخفیفان، اپلیکیشن تخفیفان، پیامک مارکتینگ، ایمیل مارکتینگ ، وب پوش، اپ پوش، پیام در اپلیکیشن، بلاگ) به صورت دوره ای تبلیغات مراکز طرف قرارداد با تخفیفان انجام می‌شود و همچنین  نمایش کسب و کار شما  به همراه میزان تخفیف بر روی پلتفرم تخفیفان و اپلیکیشن های همراه کارت ، سکه و نشان برای دیده شدن  شما و جذب مشتری بسیار موثر می‌باشد`,
					},
					{
						question: 'تخفیفان چگونه باعث بهتر دیده شدن کسب و کار من می‌شود؟',
						answer: `با فعالسازی آگهی بازگشت وجه حضوری کسب و کار شما  به همراه میزان تخفیف بر روی پلتفرم تخفیفان نمایش داده می شود و کانال‌های تبلیغاتی تخفیفان به صورت دوره ای تبلیغات با مراکز طرف قرارداد با تخفیفان انجام می‌شود همچنین اپلیکیشن های طرف قرارداد تخفیفان  برای دیده شدن  شما و جذب مشتری بسیار موثر می‌باشد.`,
					},
				],
			},
			{
				heading: 'نظرات، پرسش و پاسخ کاربران:',
				data: [
					{
						question:
							'آیا به نظرات کاربران و پاسخگویی به سوالات مشتریان دسترسی دارم؟',
						answer: `پس از ورود به پنل کسب و کار خود، از گزینه "بیشتر"، می توانید به سوالات و نظرات ثبت شده کاربران  را مشاهده و به انها پاسخ دهید. در نظر داشته باشید که پاسخگویی به سوالات کاربران در کمترین زمان ممکن می تواند به فروش بیشتر شما کمک کند.`,
					},
				],
			},
			{
				heading: 'راههای ارتباطی با تخفیفان:',
				data: [
					{
						question: 'چگونه با کارشناس پشتیبان خود در تماس باشم؟',
						answer: (
							<p className='ws-pre-wrap'>{`می توانید با ثبت تیکت در پنل، درخواست خود را مطرح کنید تا کارشناس های ما در اسرع وقت با شما تماس بگیرند.\nجهت ثبت تیکت، پس از ورود به پنل کسب و کار، از گزینه "بیشتر"، "تیکت های پشتیبانی" را انتخاب کنید.\nامکان تماس تلفنی با پشتیبانی نیز (02192005412) در همه صفحات پنل شما (بالای صفحه، سمت چپ) قابل مشاهده است.`}</p>
						),
					},
					{
						question: 'چگونه در پنل کسب و کار خود تیکت ثبت کنم؟',
						answer: (
							<p className='ws-pre-wrap'>{`پس از ورود به پنل کسب و کار، از گزینه "بیشتر"، "تیکت های پشتیبانی" را انتخاب کنید و روی علامت + پایین صفحه کلیک کنید و تیکت را ایجاد کنید. امکان بارگذاری و ارسال تصویر نیز از این بخش وجود دارد.\nتیکت های شما تا 48 ساعت پاسخ داده خواهد شد و می توانید نتیجه آن را در پنل خود مشاهده کنید.`}</p>
						),
					},
				],
			},
		],
	},
];
